/* istanbul ignore file */

import { Component, computed, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import {
    CaregiverTrainTripFormGroup,
    TrainRequestDetailsFormGroup,
} from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/train-request.formgroup';
import { MdsCheckboxComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Caregiver, getCaregiverFullName } from '@models/patient';
import { TrainDetailsComponent } from './train-details/train-details.component';

@Component({
    selector: 'medpace-train-request-details',
    templateUrl: './train-request-details.component.html',
    styleUrls: ['./train-request-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TrainDetailsComponent, MdsExpansionPanelComponent, MdsCheckboxComponent],
})
export class TrainRequestDetailsComponent {
    readonly mode: InputSignal<CardMode> = input.required();
    readonly formGroup: InputSignal<TrainRequestDetailsFormGroup> = input.required();

    public readonly accompanyingCaregivers = computed(() =>
        this.formGroup().controls.caregivers.controls.filter(
            (control) =>
                !!control.controls.details.value.trainDetails?.departureDate ||
                control.controls.details.value.bookIdenticalTrip === true
        )
    );

    public hasAnyNonDisabledCaregiverControls(caregivers: CaregiverTrainTripFormGroup[]): boolean {
        return caregivers.filter((caregiverControl) => !caregiverControl.disabled).length !== 0;
    }

    public getCaregiverFullName(caregiver: Caregiver | undefined): string {
        return caregiver ? getCaregiverFullName(caregiver) : '';
    }
}
